import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import GeneratedDocumentsResponse from "../interfaces/generatedDocumentsResponse";
import GridCellButtonWrapper from "../components/baseComponents/gridCellButtonWrapper";

const getGeneratedDocumentColumnDef = (handleGeneratedDocumentResponseClick: (link: string) => void): GridColDef[] => [
    {
        field: 'id',
        headerName: 'Generated Document ID',
        width: 300,
        renderCell: (params: GridRenderCellParams<GeneratedDocumentsResponse, any, any>) => {
            return (
                <GridCellButtonWrapper
                    onClick={() => handleGeneratedDocumentResponseClick(params.row.signed_url || '')}
                    text={params.row.id}
                />
            );
        }
    },
    { field: 'client_reference_id', headerName: 'Client Reference ID', width: 300 },
    { field: 'short_url', headerName: 'Document Link', width: 300, hideable: true, sortable: false, filterable: false },
    { field: 'created_date', headerName: 'Created Date', width: 300 }
];

export default getGeneratedDocumentColumnDef;